import React from "react";
import { Star, Quote } from "lucide-react";

const items = [
  {
    name: "Anil R.",
    role: "",
    body: "VersaCorp's printed paper cups elevated our brand instantly. Quality is rock-solid and delivery has never slipped.",
    rating: 5,
  },
  {
    name: "Sajeet Kumar",
    role: "",
    body: "We have switched all our takeaway packaging to VersaCorp. Eco-friendly, food safe, and our customers notice the difference.",
    rating: 5,
  },
  {
    name: "Rohan Shetty",
    role: "",
    body: "Tissue napkins quality is consistently premium. Their bulk supply chain is genuinely reliable.",
    rating: 5,
  },
  {
    name: "Kavya N.",
    role: "",
    body: "From sampling to full custom branding, the VersaCorp team made the entire process effortless.",
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 bg-neutral-50/60">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-3xl">
          <div className="font-mono-vc text-xs uppercase tracking-[0.25em] vc-text-gradient font-bold">
            Voices of Our Partners
          </div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl font-extrabold text-neutral-900 leading-[1.05]">
            Loved by businesses <br /> <span className="vc-text-gradient">across India.</span>
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="rounded-2xl bg-white border border-neutral-200 p-6 hover:shadow-md transition-shadow"
            >
              <Quote className="text-orange-500" size={24} />
              <blockquote className="mt-4 text-neutral-800 leading-relaxed">
                {t.body}
              </blockquote>
              <div className="mt-5 flex items-center gap-1 text-amber-500">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={`${t.name}-star-${k}`} size={14} fill="currentColor" />
                ))}
              </div>
              <figcaption className="mt-4 pt-4 border-t border-neutral-100">
                <div className="font-display font-bold text-neutral-900">{t.name}</div>
                {t.role && <div className="text-xs text-neutral-500">{t.role}</div>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
